import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class TollDiscountGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tollDiscountGrid = this;
		setTimeout(function(){
			tollDiscountGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}
	
	init() {
		var tollDiscountGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					], 
					listeners: {
						click: function() {
							actionAdd();
						}
					}
				},
				{
					tag: 'vaadin-button',											
					itemid: 'delete',
					theme: 'error primary',
					'class': 'spacer-toolbar-item',
					style: 'float: right;',				
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{
					path: 'value',
					header: 'Toll Discount Program',
					width: '9em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {	
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		tollDiscountGrid.append(flexLayout);
						
		tollDiscountGrid.addedValues = [];
		tollDiscountGrid.options = [];
		tollDiscountGrid.actionRefresh = function() {			
			grid.items = tollDiscountGrid.addedValues.slice();
		};
		
		var actionAdd = function() {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add',
				icon: 'vaadin:edit',				
				width: 500,
				height: 200,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',											
											label: 'Toll Discount', 
											name: 'tollDiscount',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function(combo) {																							
												var available = [];
												
												var addedMap = {													
												};
												tollDiscountGrid.addedValues.forEach(function(added){
													addedMap[added.value] = added;
												});
												
												tollDiscountGrid.options.forEach(function(item) {												
													if (!addedMap[item.code]) {
														available.push(item);
													}
												});
												
												combo.items = available;
											}	
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															var data = formPanel.getData();	
															tollDiscountGrid.addedValues.push({
																value: data.tollDiscount
															});
															
															tollDiscountGrid.actionRefresh();
															addEditWin.close();
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]							
						});
						addEditWin.addToContentElement(formPanel);
						
					}
				}
			});
			
		};

		var actionDelete = function(record) {
			var valueStillAdded = [];
			tollDiscountGrid.addedValues.forEach(function(item) {
				if (item.value !== record.value) {
					valueStillAdded.push(item);
				}
			});			
			tollDiscountGrid.addedValues = valueStillAdded;			
			tollDiscountGrid.actionRefresh();
		};
		
		var readyEvent = new CustomEvent('ready', { detail: tollDiscountGrid });
		tollDiscountGrid.dispatchEvent(readyEvent);	
	}
	
	getValues() {
		var tollDiscountGrid = this;
		var decodedValues = [];
		tollDiscountGrid.addedValues.forEach(function(record){
			decodedValues.push(record.value);
		});
		
		return decodedValues;
	}
	
	setValues(values) {
		var tollDiscountGrid = this;
		
		var loadValues = [];
		if (values) {
			values.forEach(function(record){
				loadValues.push({
					value: record
				});
			});
		}
		
		tollDiscountGrid.addedValues = loadValues;
		tollDiscountGrid.actionRefresh();
	}
	
}
customElements.define('dl-toll-discount', TollDiscountGrid);

